<template>
  <div class="submenu-container">
    <div
      class="submenu-header tw-flex tw-items-center tw-justify-between tw-cursor-pointer tw-py-1 tw-pr-2"
      @click="toggle"
    >
      <div class="submenu-title tw-flex tw-w-full tw-items-center tw-gap-2 tw-relative">
        <slot name="icon" />
        <slot name="title" />
      </div>
      <div
        v-if="hasContent"
        class="submenu-arrow tw-absolute tw-transition-transform tw-duration-300"
        :class="{ 'tw-rotate-180': isOpen }"
      >
        <icon-angle-down />
      </div>
    </div>

    <div
      v-if="hasContent"
      class="submenu-content-wrapper tw-overflow-hidden tw-bg-white tw-transition-all tw-duration-300"
      :style="{ maxHeight: dynamicHeight, opacity }"
    >
      <div
        ref="submenuContent"
        class="submenu-content tw-px-2 tw-py-1"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppNavSubmenu',
  props: {
    forceCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      dynamicHeight: '0px',
      opacity: 0,
    };
  },
  computed: {
    hasContent() {
      return !!this.$slots.default;
    },
  },
  watch: {
    forceCollapse: {
      immediate: true,
      handler(value) {
        if (value) {
          this.isOpen = false;
          this.dynamicHeight = '0px';
          this.opacity = 0;
        }
      },
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        this.$nextTick(() => {
          const childContent = this.$refs.submenuContent;
          if (childContent) {
            this.dynamicHeight = childContent.scrollHeight + 'px';
            this.opacity = 1;
          }
        });
      } else {
        this.dynamicHeight = '0px';
        this.opacity = 0;
      }
    },
  },
};
</script>

<style scoped>
.submenu-container {
  width: max(20%, 362px);
}

.submenu-arrow {
  left: max(332px, calc(20% - 10px));
}
</style>
